(() => {
  function initialize(host) {
    if (location.origin !== 'https://sakedoo.com') return;
    if (host.dataset.mashoyoReady) return;
    host.dataset.mashoyoReady = 'true';
    let endpoint;
    try {
      endpoint = new URL(host.dataset.endpoint || 'https://klmlsreorpxfbyvrpztr.supabase.co/functions/v1/sakedo-reviews');
      if (endpoint.href !== 'https://klmlsreorpxfbyvrpztr.supabase.co/functions/v1/sakedo-reviews'
        || host.dataset.site !== 'mwp_sakedoo_v1') return;
    } catch { return; }
    const shadow = host.attachShadow({ mode: 'open' });
    const style = document.createElement('style');
    style.textContent = `:host{display:block;min-width:0;container-type:inline-size;font-family:system-ui,sans-serif;color:#454545}
      *{box-sizing:border-box}[hidden]{display:none!important}
      section{margin:24px 0 26px;padding:16px 0;background:transparent;border-top:1px solid #ddd;border-bottom:1px solid #ddd;min-width:0}
      header,.meta,footer,.controls{display:flex;align-items:center}header{gap:9px;margin-bottom:12px;min-height:32px}
      h3{font-size:16px;font-weight:500;letter-spacing:0;margin:0}.count{font-size:11px;color:#777;white-space:nowrap}
      .track{display:flex;align-items:flex-start;gap:12px;overflow-x:auto;scroll-snap-type:x mandatory;overscroll-behavior-x:contain;scrollbar-width:none}
      .track::-webkit-scrollbar{display:none}.track:focus-visible{outline:2px solid #425482;outline-offset:2px}
      article{flex:0 0 calc((100% - 30px)/3.5);min-width:0;scroll-snap-align:start;scroll-snap-stop:always}
      .card{width:100%;height:auto;display:flex;flex-direction:column;align-items:stretch;justify-content:flex-start;overflow:hidden;border:1px solid #e1e1e1;border-radius:2px;background:#fff;text-align:left;padding:12px;transition:background .15s,border-color .15s}
      .card[aria-expanded=true]{border-color:#888;background:#fafafa}.card:hover:not(:disabled){border-color:#aaa;background:#fafafa}
      .meta{gap:7px;font-size:12px;min-width:0}.meta strong{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;min-width:0;flex:1}
      .meta strong{font-weight:500}.score{margin-left:auto;white-space:nowrap;font-weight:500;color:#666}
      .card .meta,.preview{width:100%;min-width:0;max-width:100%}.preview{display:block;font-size:12px;line-height:1.7;margin-top:6px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:#777}
      .expanded{display:grid;grid-template-rows:0fr;visibility:hidden;transition:grid-template-rows .2s ease,visibility .2s}
      .expanded[data-open=true]{grid-template-rows:1fr;visibility:visible}.expanded-inner{min-height:0;overflow:hidden}
      .expanded-content{margin-top:12px;padding:14px 16px;background:#fff;border:1px solid #e1e1e1;border-radius:2px}
      .expanded p{font-size:13px;line-height:1.7;white-space:pre-wrap;overflow-wrap:anywhere;margin:6px 0 8px}
      .detail-bottom{display:flex;align-items:center;justify-content:space-between;gap:8px;font-size:11px}
      .date{color:#777;font-size:11px}a{color:#555;text-underline-offset:3px}
      footer{justify-content:space-between;gap:10px;margin-top:12px;font-size:11px}footer>a{text-decoration:none;white-space:nowrap;font-weight:600}
      .controls{gap:0;margin-left:auto}.position{min-width:34px;text-align:center;color:#777;font-size:11px;font-variant-numeric:tabular-nums}
      button{width:32px;height:32px;border:1px solid #ddd;background:#fff;border-radius:2px;color:#555;font:inherit;cursor:pointer;display:grid;place-items:center}
      button:hover:not(:disabled){background:#f5f5f5}button:disabled{opacity:.25;cursor:default}button:focus-visible,a:focus-visible{outline:2px solid #425482;outline-offset:2px}
      .chevron{width:8px;height:8px;border-top:1.5px solid currentColor;border-right:1.5px solid currentColor;transform:rotate(45deg)}.previous .chevron{transform:rotate(-135deg)}
      .notice{display:block;font-size:11px;color:#777;line-height:1.5}
      @container(max-width:600px){section{padding:14px 0;margin:18px 0 22px}article{flex-basis:calc((100% - 18px)/2.2)}header{flex-wrap:wrap;gap:6px;margin-bottom:10px}h3{font-size:15px}.position{min-width:28px}footer{align-items:flex-start;flex-wrap:wrap}button{width:44px;height:44px}.card{width:100%;height:auto;min-height:64px;padding:10px}.meta{font-size:11px;gap:5px}.expanded-content{padding:12px}}
      @media(prefers-reduced-motion:reduce){.track{scroll-behavior:auto}.expanded{transition:none}}`;
    shadow.append(style);
    const region = document.createElement('section');
    region.setAttribute('aria-label', '마셔요 리뷰');
    region.hidden = true;
    shadow.append(region);
    const text = (tag, value, parent, className) => {
      const el = document.createElement(tag); el.textContent = String(value || '');
      if (className) el.className = className;
      parent.append(el); return el;
    };
    const link = (label, url, parent) => {
      try {
        const parsed = new URL(url);
        if (parsed.origin !== 'https://mashoyo.com' || !['/detail', '/review'].includes(parsed.pathname)) return;
        const el = text('a', label, parent); el.href = parsed.href; el.target = '_blank'; el.rel = 'noopener noreferrer';
      } catch { /* invalid links are not rendered */ }
    };
    let busy = false;
    let visible = true;
    let signature = '';
    let trackResizeObserver;
    const hide = () => { signature = ''; trackResizeObserver?.disconnect(); region.replaceChildren(); region.hidden = true; };
    function render(data) {
      const reviews = data.reviews.slice(0, 5);
      const header = text('header', '', region);
      text('h3', '마셔요 리뷰', header);
      text('span', `${reviews.length}개의 이야기`, header, 'count');
      const track = text('div', '', region, 'track');
      track.id = 'review-track';
      track.tabIndex = 0;
      track.setAttribute('role', 'group');
      track.setAttribute('aria-label', `${data.product} 리뷰, 좌우 방향키로 이동`);
      const panel = text('div', '', region, 'expanded');
      panel.id = 'review-expanded';
      panel.setAttribute('role', 'region');
      panel.setAttribute('aria-label', '선택한 리뷰 내용');
      panel.setAttribute('aria-hidden', 'true');
      panel.inert = true;
      const inner = text('div', '', panel, 'expanded-inner');
      let selected = -1;
      function toggleReview(i) {
        selected = selected === i ? -1 : i;
        track.querySelectorAll('.card').forEach((card, n) => card.setAttribute('aria-expanded', String(n === selected)));
        panel.dataset.open = String(selected !== -1);
        panel.setAttribute('aria-hidden', String(selected === -1));
        panel.inert = selected === -1;
        if (selected === -1) return;
        const review = reviews[selected];
        inner.replaceChildren();
        const content = text('div', '', inner, 'expanded-content');
        text('strong', review.nickname, text('div', '', content, 'meta'));
        text('p', review.excerpt, content);
        const bottom = text('div', '', content, 'detail-bottom');
        const date = new Date(review.created_at);
        if (Number.isFinite(date.getTime())) text('span', date.toLocaleDateString('ko-KR'), bottom, 'date');
        link('원문 전체 보기 ↗', review.url, bottom);
      }
      for (const [i, review] of reviews.entries()) {
        const article = text('article', '', track);
        article.setAttribute('aria-label', `${i + 1} / ${reviews.length} 리뷰`);
        const card = text('button', '', article, 'card');
        card.type = 'button';
        card.setAttribute('aria-expanded', 'false');
        card.setAttribute('aria-controls', panel.id);
        card.addEventListener('click', () => toggleReview(i));
        const meta = text('span', '', card, 'meta');
        text('strong', review.nickname, meta);
        if (Number.isInteger(review.score) && review.score >= 1 && review.score <= 5) text('span', `★ ${review.score}.0`, meta, 'score');
        text('span', review.excerpt, card, 'preview');
      }
      const footer = text('footer', '', region);
      text('small', '마셔요 회원 리뷰 · 사케도 구매 인증 후기 아님', footer, 'notice');
      link('마셔요에서 더 보기 ↗', data.moreUrl, footer);
      const controls = text('div', '', header, 'controls');
      controls.hidden = reviews.length < 2;
      function arrow(label, className) {
        const button = text('button', '', controls, className);
        button.type = 'button';
        button.setAttribute('aria-label', label);
        button.setAttribute('aria-controls', track.id);
        text('span', '', button, 'chevron').setAttribute('aria-hidden', 'true');
        return button;
      }
      const previous = arrow('이전 리뷰', 'previous');
      const position = text('span', '', controls, 'position');
      position.setAttribute('aria-live', 'polite');
      position.setAttribute('aria-atomic', 'true');
      const next = arrow('다음 리뷰', 'next');
      let index = 0;
      function update() {
        controls.hidden = reviews.length < 2 || (track.clientWidth > 0 && track.scrollWidth <= track.clientWidth + 1);
        position.textContent = `${index + 1} / ${reviews.length}`;
        previous.disabled = track.scrollLeft <= 1;
        next.disabled = track.clientWidth > 0 ? track.scrollLeft >= track.scrollWidth - track.clientWidth - 1 : index === reviews.length - 1;
      }
      function move(to) {
        index = Math.max(0, Math.min(reviews.length - 1, to));
        const card = track.children[index];
        const desired = card.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
        const left = track.clientWidth > 0 ? Math.min(desired, Math.max(0, track.scrollWidth - track.clientWidth)) : desired;
        track.scrollTo({ left, behavior: window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        update();
      }
      previous.addEventListener('click', () => move(index - 1));
      next.addEventListener('click', () => move(index + 1));
      track.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        move(event.key === 'Home' ? 0 : event.key === 'End' ? reviews.length - 1 : index + (event.key === 'ArrowRight' ? 1 : -1));
      });
      track.addEventListener('scroll', () => {
        const left = track.getBoundingClientRect().left;
        let nearest = 0;
        for (let i = 1; i < track.children.length; i++) {
          if (Math.abs(track.children[i].getBoundingClientRect().left - left) < Math.abs(track.children[nearest].getBoundingClientRect().left - left)) nearest = i;
        }
        index = nearest;
        update();
      }, { passive: true });
      if (typeof ResizeObserver !== 'undefined') {
        trackResizeObserver = new ResizeObserver(update);
        trackResizeObserver.observe(track);
      }
      update();
    }
    async function refresh() {
      if (busy || !host.isConnected || document.hidden || !visible) return;
      busy = true;
      try {
        const name = (host.dataset.product || document.querySelector(host.dataset.productSelector || 'h1')?.textContent || '').trim();
        if (name.length < 3 || name.length > 160) throw new Error('Invalid product');
        const url = new URL(endpoint); url.searchParams.set('product', name);
        url.searchParams.set('site', host.dataset.site);
        const response = await fetch(url, { credentials: 'omit', cache: 'no-store', signal: AbortSignal.timeout(10000) });
        if (!response.ok) throw new Error('Unavailable');
        const data = await response.json();
        if (document.hidden || !host.isConnected || data.match !== 'exact_alias' || !Array.isArray(data.reviews) || !data.reviews.length) { hide(); return; }
        const nextSignature = JSON.stringify([data.product, data.moreUrl, data.reviews.slice(0, 5)]);
        if (signature === nextSignature && !region.hidden) return;
        hide();
        render(data);
        signature = nextSignature;
        region.hidden = false;
      } catch {
        hide();
      } finally { busy = false; }
    }
    const timer = setInterval(() => {
      if (!host.isConnected) { clearInterval(timer); observer?.disconnect(); return; }
      void refresh();
    }, 60000);
    const observer = typeof IntersectionObserver === 'undefined' ? null : new IntersectionObserver(entries => {
      visible = entries[0]?.isIntersecting ?? true;
      if (visible) void refresh();
    });
    observer?.observe(host);
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) hide();
      else void refresh();
    });
    void refresh();
  }
  const start = () => document.querySelectorAll('[data-mashoyo-reviews]').forEach(initialize);
  document.addEventListener('shopify:section:load', start);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
